import { render } from "./VideoCp.vue?vue&type=template&id=1caf1cd6&scoped=true"
import script from "./VideoCp.vue?vue&type=script&lang=js"
export * from "./VideoCp.vue?vue&type=script&lang=js"

import "./VideoCp.vue?vue&type=style&index=0&id=1caf1cd6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1caf1cd6"]])

export default __exports__